<template>
  <GenericBanner :displayed="displayed" class="search-banner bg-bannerGreen-search-bar">
    <div class="flex w-full flex-col md:gap-7 md:px-4 md:flex-row">
      <div class="lg:basis-3/4">
        <p class="lg:text-3xl font-black leading-6 text-xl">
          Q. What's the best way to use the next 2 minutes?
        </p>

        <p class="lg:text-2xl font-bold leading-5 md:mb-4 text-sm">
          A. Upload or update your CV on
          <a
            class="cursor-pointer underline"
            target="_blank"
            :href="cvLibraryAffiliateLink"
            >CV&#8209;Library</a
          >
          and let the right recruiters find you!
        </p>

        <p class="text-small hidden text-[#265212] md:block leading-tight">
          Save yourself hours by uploading or updating your CV on our partner
          site
          <a class="underline" target="_blank" :href="cvLibraryAffiliateLink"
            >CV-Library.co.uk</a
          >. With over 200,000 live vacancies, your next {{ industry }} job
          {{ inLocation }} could be in your inbox tomorrow.
        </p>
      </div>

      <div
        class="flex w-full justify-between gap-4 md:flex-col md:justify-start md:gap-8 lg:basis-1/4"
      >
        <InputButton
          type="button"
          class="basis-1/2 rounded-md border border-lime-800 bg-[#57b12d] lg:text-sm text-[#346d19] md:basis-0"
          block
          styleType="none"
          @click="$emit('closeButtonClick')"
        >
          Close & don't upload CV
        </InputButton>

        <a
          :href="cvLibraryAffiliateLink"
          target="_blank"
          class="h-full basis-1/2 md:basis-0"
        >
          <InputButton
            type="button"
            class="rounded-md bg-white hover:bg-grey-20 px-6 font-bold lg:text-lg text-[#3e8020] focus:outline-none md:text-sm"
            block
            styleType="none"
          >
            Upload your CV and Apply for jobs
          </InputButton>
        </a>
      </div>
    </div>
  </GenericBanner>
</template>

<script>
import GenericBanner from 'Components/Banners/GenericBanner';
import IconCross from 'Components/Icons/IconCross';
import InputButton from 'Components/InputButton.vue';

export default {
  name: 'CandidateSearchBanner',
  components: {
    GenericBanner,
    IconCross,
    InputButton,
  },
  data() {
    return {
      cvLibraryAffiliateLink: 'https://www.cv-library.co.uk/register?id=104271',
    };
  },
  props: {
    displayed: {
      type: Boolean,
      default: true,
    },
    industry: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: '',
    },
  },
  computed: {
    inLocation() {
      return !this.location ? '' : `in ${this.location}`;
    },
  },
};
</script>
